import makeActionCreator from 'src/lib/makeActionCreator';
import {
  Ambassador,
  AmbassadorInvitationData,
  AmbassadorInvitationPayload,
  AmbassadorPayload, AmbassadorUpdateMessagePayload,
} from 'src/models/FundraisingModel';
import { State } from 'src/redux/reducers/RootReducer';
import {
  deleteAmbassadorData,
  getAmbassadorByIdData,
  getAmbassadorListData,
  postAmbassadorData,
  putAmbassadorData, postAmbassadorInvitationData, putAmbassadorUpdateMessageData,
} from 'src/apis/FundraisingAPI';
import Debug from 'src/lib/Debug';
import { setAlert } from 'src/redux/actions/alertActions';
import { ALERT_TYPE } from 'src/constants/AlertType';

export const ADD_AMBASSADOR = 'ADD_AMBASSADOR';
export const REMOVE_AMBASSADOR = 'REMOVE_AMBASSADOR';
export const REPLACE_AMBASSADOR = 'REPLACE_AMBASSADOR';
export const SET_AMBASADOR_LIST = 'SET_AMBASADOR_LIST';

export const addAmbassadorAction = makeActionCreator(ADD_AMBASSADOR);
export const removeAmbassadorAction = makeActionCreator(REMOVE_AMBASSADOR);
export const updateAmbassadorAction = makeActionCreator(REPLACE_AMBASSADOR);
export const setAmbassadorListAction = makeActionCreator(SET_AMBASADOR_LIST);

export const getAmbassadorListAction: (fundraisingId: string | number) => ThunkedAction<State> =
  (fundraisingId: string | number) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await getAmbassadorListData(organisation, fundraisingId);
      if (response.success) {
        const data = response.data.map((ambassador: Ambassador) => ({
          ...ambassador,
          fundraising_id: response.data.event_id,
        }));

        dispatch(setAmbassadorListAction(data));
      }
    } catch (e) { /* Log the error here */
    }
  };

export const sendAmbassadorInvitationAction:
(fundraisingId: string | number, payload: AmbassadorInvitationPayload) => ThunkedAction<State> =
  (
    fundraisingId: string | number,
    payload: AmbassadorInvitationPayload,
  ) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const data = {
        ambassador_ids: payload.selected,
        send_by: payload.delivery,
        all: payload.all ?? false,
        message: payload.message,
      } as AmbassadorInvitationData;
      const response = await postAmbassadorInvitationData(organisation, data);
      if (response.success) {
        dispatch(getAmbassadorListAction(fundraisingId));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: 'Invitation successfully sent',
        }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error sending invitation',
      }));
    } catch (e) {
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error sending invitation',
      }));
    }
  };

export const updateAmbassadorMessageAction:
(fundraisingId: string | number, payload: AmbassadorUpdateMessagePayload) => ThunkedAction<State> =
  (
    fundraisingId: string | number,
    payload: AmbassadorUpdateMessagePayload,
  ) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await putAmbassadorUpdateMessageData(organisation, payload);
      if (response.success) {
        dispatch(getAmbassadorListAction(fundraisingId));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: 'Message successfully updated',
        }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error updating message',
      }));
    } catch (e) {
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error updating message',
      }));
    }
  };

export const getAmbassadorByIdAction: (id: string | number) => ThunkedAction<State> =
  (id: string | number) => async (dispatch: any, getState: any) => {
    if (!id) {
      return;
    }
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await getAmbassadorByIdData(id, organisation);
      if (response.success) {
        const data = {
          ...response.data,
          fundraising_id: response.data.event_id,
        } as Ambassador;
        dispatch(updateAmbassadorAction(data));
      }
    } catch (e) { /* Log the error here */
      Debug.log(e);
    }
  };

export const postAmbassadorAction:
(ambassador: AmbassadorPayload) => ThunkedAction<State> =
  (ambassador: AmbassadorPayload) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await postAmbassadorData(organisation, ambassador);
      if (response.success && (!!response.data)) {
        const data = {
          ...response.data,
          fundraising_id: response.data.event_id,
        } as Ambassador;
        dispatch(addAmbassadorAction(data));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: 'Ambassador successfully saved',
        }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error saving Ambassador',
      }));
    } catch (e) { /* Log the error here */
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error saving Ambassador',
      }));
    }
  };

export const putAmbassadorAction: (ambassador: AmbassadorPayload) => ThunkedAction<State> =
  (ambassador: AmbassadorPayload) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await putAmbassadorData(organisation, ambassador);
      if (response.success && (!!response.data)) {
        const data = {
          ...response.data,
          fundraising_id: response.data.event_id,
        } as Ambassador;
        dispatch(updateAmbassadorAction(data));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: 'Ambassador successfully saved',
        }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error saving Ambassador',
      }));
    } catch (e) { /* Log the error here */
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error saving Ambassador',
      }));
    }
  };

export const deleteAmbassadorAction: (id: number) => ThunkedAction<State> =
  (id: number) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await deleteAmbassadorData(id, organisation);
      if (response.success) {
        dispatch(removeAmbassadorAction(id));
        dispatch(setAlert({
          type: ALERT_TYPE.error,
          message: 'Ambassador successfully deleted',
        }));
      }
      dispatch(setAlert({
        type: ALERT_TYPE.success,
        message: 'Error deleting Ambassador',
      }));
    } catch (e) { /* Log the error here */
      dispatch(setAlert({
        type: ALERT_TYPE.success,
        message: 'Error deleting Ambassador',
      }));
    }
  };
